export { ReactComponent as AppLogo } from './app-logo.svg';
export { ReactComponent as NotFound } from './not-found.svg';
export { ReactComponent as EmptyBox } from './empty-box.svg';
export { ReactComponent as RobotSleep } from './robot-sleep.svg';
export { ReactComponent as AppIcon } from './app-icon.svg';
export { ReactComponent as GoogleLogo } from './google-logo.svg';
